@if (!pia.is_example) {
<div
  class="pia-cardsBlock pia"
  [ngClass]="{
    'pia-exampleBlock': pia.is_example === 1,
    'pia-archiveBlock': pia.status > 1,
    'pia-doingBlock': pia.status < 2
  }"
  [attr.data-id]="pia.id"
>
  @if (pia.id !== null) {
  <div class="pia-cardsBlock-header-title">
    @if (!previousPia || previousPia.status !== pia.status) {
    <span>{{ piaService.getStatusName(pia.status) | translate }}</span>
    }
  </div>
  }
  <div class="pia-cardsBlock-item pia-doingBlock-item">
    @if (attachments && attachments.length > 0) {
    <div class="pia-cardsBlock-item-attachment" aria-hidden="true">
      <span class="pia-icons pia-icon-attachment"></span>
      <ul>
        @for (attachment of attachments; track attachment) {
        <li>{{ attachment.name }}</li>
        }
      </ul>
    </div>
    } @if ( !authService.state ||
    authService.currentUserValue.access_type.includes('technical') ||
    authService.currentUserValue.access_type.includes('functional') ) {
    <div class="pia-cardsBlock-toolbar">
      <div class="pia-cardsBlock-toolbar-export">
        @if (pia.status >= 2) {
        <a
          [routerLink]="['/pia', pia.id, 'section', 1, 'item', 1]"
          class="btn pia-tooltip"
        >
          <fa-icon [icon]="faPencil"></fa-icon>
          <span
            title="{{ 'homepage.cards.item.edit_pia' | translate }}"
            class="pia-tooltip-text"
            >{{ "homepage.cards.item.edit_pia" | translate }}</span
          >
        </a>
        }
        <a
          href="javascript:;"
          (click)="onDuplicate(pia.id)"
          class="btn pia-tooltip"
        >
          <fa-icon [icon]="faCopy"></fa-icon>
          <span
            title="{{ 'homepage.cards.item.tools.duplicate' | translate }}"
            class="pia-tooltip-text"
            >{{ "homepage.cards.item.tools.duplicate" | translate }}</span
          >
        </a>
        <a href="javascript:;" (click)="generateZip()" class="btn pia-tooltip">
          <fa-icon [icon]="faDownload"></fa-icon>
          <span
            title="{{ 'homepage.cards.item.tools.export' | translate }}"
            class="pia-tooltip-text"
            >{{ "homepage.cards.item.tools.export" | translate }}</span
          >
        </a>
        <a
          href="javascript:;"
          (click)="archivePia(pia.id)"
          class="btn pia-tooltip"
        >
          <fa-icon [icon]="faArchive"></fa-icon>
          <span
            title="{{ 'homepage.cards.item.tools.archive' | translate }}"
            class="pia-tooltip-text"
            >{{ "homepage.cards.item.tools.archive" | translate }}</span
          >
        </a>
      </div>
    </div>
    } @if (piaForm) {
    <form class="pia-cardsBlock-item-form" [formGroup]="piaForm">
      <input type="hidden" formControlName="id" />
      <div (click)="piaNameFocusIn()" style="margin-top:20px;">
        <label for="pia-edit-{{ pia.id }}-name">{{
          "homepage.cards.pia_name" | translate
        }}</label>
        <input
          type="text"
          #piaName
          formControlName="name"
          required
          placeholder="{{ 'homepage.cards.placeholder_pia_name' | translate }}"
          id="pia-edit-{{ pia.id }}-name"
          (focusout)="piaNameFocusOut()"
        />
      </div>
      <div>
        <label for="pia-edit-{{ pia.id }}-author-name">{{
          "homepage.cards.author" | translate
        }}</label>
        @if (authService.state) {
        <div class="tag-input-container">
          @if (!isInputDisabled()) {
          <tag-input
            #input
            id="pia-edit-{{ pia.id }}-author-name"
            [disable]="isInputDisabled()"
            identifyBy="id"
            displayBy="display"
            formControlName="authors"
            (onAdd)="onAddUser($event, 'authors')"
            (onRemove)="onRemove($event, 'authors')"
            [theme]="'foundation-theme'"
            (onTextChange)="onTyped($event, pia.id, 'authors')"
            [editable]="false"
            [clearOnBlur]="true"
            [placeholder]="'homepage.cards.placeholder_author' | translate"
            [secondaryPlaceholder]="
              'homepage.cards.placeholder_author' | translate
            "
          >
            <ng-template let-item="item" let-index="index">
              <div
                [ngClass]="{
                  'custom-tag': true,
                  'user-not-found': item.id == null
                }"
              >
                {{ item.display }}
                @if ( authService.currentUserValue.access_type.includes(
                'functional' ) ) {
                <delete-icon
                  (click)="input.removeItem(item, index)"
                ></delete-icon>
                }
              </div>
            </ng-template>
            <tag-input-dropdown
              [keepOpen]="false"
              identifyBy="id"
              [showDropdownIfEmpty]="true"
              [autocompleteItems]="userList"
            ></tag-input-dropdown>
          </tag-input>
          @if ( addBtnForSpecificInput && addBtnForSpecificInput.pia_id ===
          pia.id && addBtnForSpecificInput.field === 'authors' ) {
          <button
            type="button"
            class="btn btn-add-user"
            (click)="
              onAddUserWithIcon(
                {
                  display: addBtnForSpecificInput.display,
                  id: addBtnForSpecificInput.display
                },
                'authors'
              )
            "
          >
            +
          </button>
          } } @else {
          <ul class="pia-listBlock">
            @for (item of piaForm.controls.authors.value; track item) {
            <li class="pia-listItem">
              {{ item.display }}
            </li>
            }
          </ul>
          }
        </div>
        } @else {
        <div (click)="piaAuthorNameFocusIn()">
          <input
            type="text"
            #piaAuthorName
            formControlName="author_name"
            required
            placeholder="{{ 'homepage.cards.placeholder_author' | translate }}"
            id="pia-edit-{{ pia.id }}-author-name"
            (focusout)="piaAuthorNameFocusOut()"
          />
        </div>
        }
      </div>
      <div>
        <label for="pia-edit-{{ pia.id }}-evaluator-name">{{
          "homepage.cards.evaluation" | translate
        }}</label>
        @if (authService.state) {
        <div class="tag-input-container">
          @if (!isInputDisabled()) {
          <tag-input
            #input
            id="pia-edit-{{ pia.id }}-evaluator-name"
            [disable]="isInputDisabled()"
            identifyBy="id"
            formControlName="evaluators"
            (onTextChange)="onTyped($event, pia.id, 'evaluators')"
            (onAdd)="onAddUser($event, 'evaluators')"
            (onRemove)="onRemove($event, 'evaluators')"
            [theme]="'foundation-theme'"
            [editable]="false"
            [clearOnBlur]="true"
            [placeholder]="'homepage.cards.placeholder_evaluation' | translate"
            [secondaryPlaceholder]="
              'homepage.cards.placeholder_evaluation' | translate
            "
          >
            <ng-template let-item="item" let-index="index">
              <div
                [ngClass]="{
                  'custom-tag': true,
                  'user-not-found': item.id == null
                }"
              >
                {{ item.display }}
                @if ( authService.currentUserValue.access_type.includes(
                'functional' ) ) {
                <delete-icon
                  (click)="input.removeItem(item, index)"
                ></delete-icon>
                }
              </div>
            </ng-template>
            <tag-input-dropdown
              [keepOpen]="false"
              identifyBy="id"
              [showDropdownIfEmpty]="true"
              [autocompleteItems]="userList"
            ></tag-input-dropdown>
          </tag-input>
          @if ( addBtnForSpecificInput && addBtnForSpecificInput.pia_id ===
          pia.id && addBtnForSpecificInput.field === 'evaluators' ) {
          <button
            type="button"
            class="btn btn-add-user"
            (click)="
              onAddUserWithIcon(
                {
                  display: addBtnForSpecificInput.display,
                  id: addBtnForSpecificInput.display
                },
                'evaluators'
              )
            "
          >
            +
          </button>
          } } @else {
          <ul class="pia-listBlock">
            @for (item of piaForm.controls.evaluators.value; track item) {
            <li class="pia-listItem">
              {{ item.display }}
            </li>
            }
          </ul>
          }
        </div>
        } @else {
        <div (click)="piaEvaluatorNameFocusIn()">
          <input
            type="text"
            #piaEvaluatorName
            formControlName="evaluator_name"
            required
            placeholder="{{
              'homepage.cards.placeholder_evaluation' | translate
            }}"
            id="pia-edit-{{ pia.id }}-evaluator-name"
            (focusout)="piaEvaluatorNameFocusOut()"
          />
        </div>
        }
      </div>
      <div>
        <label for="pia-edit-{{ pia.id }}-validator-name">{{
          "homepage.cards.validation" | translate
        }}</label>
        @if (authService.state) {
        <div class="tag-input-container">
          @if (!isInputDisabled()) {
          <tag-input
            #input
            id="pia-edit-{{ pia.id }}-validators"
            [disable]="isInputDisabled()"
            identifyBy="id"
            formControlName="validators"
            (onTextChange)="onTyped($event, pia.id, 'validators')"
            (onAdd)="onAddUser($event, 'validators')"
            (onRemove)="onRemove($event, 'validators')"
            [theme]="'foundation-theme'"
            [editable]="false"
            [clearOnBlur]="true"
            [placeholder]="'homepage.cards.placeholder_validation' | translate"
            [secondaryPlaceholder]="
              'homepage.cards.placeholder_validation' | translate
            "
          >
            <ng-template let-item="item" let-index="index">
              <div
                [ngClass]="{
                  'custom-tag': true,
                  'user-not-found': item.id == null
                }"
              >
                {{ item.display }}
                @if ( authService.currentUserValue.access_type.includes(
                'functional' ) ) {
                <delete-icon
                  (click)="input.removeItem(item, index)"
                ></delete-icon>
                }
              </div>
            </ng-template>
            <tag-input-dropdown
              [keepOpen]="false"
              identifyBy="id"
              [showDropdownIfEmpty]="true"
              [autocompleteItems]="userList"
            ></tag-input-dropdown>
          </tag-input>
          @if ( addBtnForSpecificInput && addBtnForSpecificInput.pia_id ===
          pia.id && addBtnForSpecificInput.field === 'validator_name' ) {
          <button
            type="button"
            class="btn btn-add-user"
            (click)="
              onAddUserWithIcon(
                {
                  display: addBtnForSpecificInput.display,
                  id: addBtnForSpecificInput.display
                },
                'validator_name'
              )
            "
          >
            +
          </button>
          } } @else {
          <ul class="pia-listBlock">
            @for (item of piaForm.controls.validators.value; track item) {
            <li class="pia-listItem">
              {{ item.display }}
            </li>
            }
          </ul>
          }
        </div>
        } @else {
        <div (click)="piaValidatorNameFocusIn()">
          <input
            type="text"
            #piaValidatorName
            formControlName="validator_name"
            required
            placeholder="{{
              'homepage.cards.placeholder_validation' | translate
            }}"
            id="pia-edit-{{ pia.id }}-validator-name"
            (focusout)="piaValidatorNameFocusOut()"
          />
        </div>
        }
      </div>
      @if (authService.state) {
      <div class="tag-input-container">
        <label for="pia-edit-{{ pia.id }}-guest-name">{{
          "homepage.cards.guest" | translate
        }}</label>
        @if (!isInputDisabled()) {
        <tag-input
          #input
          class="pia-users-tags"
          id="pia-edit-{{ pia.id }}-guest-name"
          [disable]="isInputDisabled()"
          identifyBy="id"
          formControlName="guests"
          (onTextChange)="onTyped($event, pia.id, 'guests')"
          (onAdd)="onAddUser($event, 'guests')"
          (onRemove)="onRemove($event, 'guests')"
          [theme]="'foundation-theme'"
          [editable]="false"
          [clearOnBlur]="true"
          [placeholder]="'homepage.cards.placeholder_validation' | translate"
          [secondaryPlaceholder]="
            'homepage.cards.placeholder_validation' | translate
          "
        >
          <ng-template let-item="item" let-index="index">
            <div [ngClass]="{ 'custom-tag': true }">
              {{ item.display }}
              @if ( authService.currentUserValue.access_type.includes(
              'functional' ) ) {
              <delete-icon
                (click)="input.removeItem(item, index)"
              ></delete-icon>
              }
            </div>
          </ng-template>
          <tag-input-dropdown
            [keepOpen]="false"
            identifyBy="id"
            [showDropdownIfEmpty]="true"
            [autocompleteItems]="usersForGuests"
          ></tag-input-dropdown>
        </tag-input>
        @if ( addBtnForSpecificInput && addBtnForSpecificInput.pia_id === pia.id
        && addBtnForSpecificInput.field === 'guests' ) {
        <button
          type="button"
          class="btn btn-add-user"
          (click)="
            onAddUserWithIcon(
              {
                display: addBtnForSpecificInput.display,
                id: addBtnForSpecificInput.display
              },
              'guests'
            )
          "
        >
          +
        </button>
        } } @else {
        <ul class="pia-listBlock">
          @for (item of piaForm.controls.guests.value; track item) {
          <li class="pia-listItem">
            {{ item.display }}
          </li>
          }
        </ul>
        }
      </div>
      }
      <div (click)="piaCategoryFocusIn()">
        <label for="pia-edit-{{ pia.id }}-category">{{
          "homepage.cards.category" | translate
        }}</label>
        <input
          type="text"
          #piaCategory
          formControlName="category"
          placeholder="{{ 'homepage.cards.placeholder_category' | translate }}"
          id="pia-edit-{{ pia.id }}-category"
          (focusout)="piaCategoryFocusOut()"
        />
      </div>
      @if (pia.structure_id) {
      <div class="pia-cardsBlock-item-structure">
        <div>{{ "homepage.cards.structure" | translate }}</div>
        <span>{{ pia.structure_name }}</span>
      </div>
      }
      <div class="pia-cardsBlock-item-date">
        <div>{{ "homepage.cards.date" | translate }}</div>
        <time
          >{{
            pia.created_at
              | date: "shortDate":"":languagesService.selectedLanguage
          }}
        </time>
      </div>
      <div class="pia-cardsBlock-item-status">
        <div class="pia-cardsBlock-item-status-infos">
          <div>{{ "homepage.cards.status" | translate }}</div>
          @if ( pia.status === 0 && pia.progress === 100) {
          <div class="pendingValidation">
            {{ "pia.statuses.5" | translate }}
          </div>
          } @else {
          <div>{{ piaService.getStatusName(pia.status) | translate }}</div>
          }
        </div>
        <div class="pia-cardsBlock-item-status-progressBar">
          <div>{{ pia.progress < 100 ? pia.progress : 100 }}%</div>
          <progress max="100" value="{{ pia.progress }}"></progress>
        </div>
      </div>
      <div class="pia-cardsBlock-item-btn">
        @if (pia.status === 0 || pia.status === 1) {
        <div class="pia-cardsBlock-item-btn-single">
          @if (pia.progress >= 96) {
          <a
            [routerLink]="['/pia', pia.id, 'section', 1, 'item', 1]"
            title="{{ 'homepage.cards.item.edit_pia' | translate }}"
            class="btn btn-green"
            [class.disabled]="piaForm.invalid"
            >{{ "homepage.cards.item.validate_pia" | translate }}
          </a>
          } @else {
          <a
            [routerLink]="['/pia', pia.id, 'section', 1, 'item', 1]"
            title="{{ 'homepage.cards.item.edit_pia' | translate }}"
            class="btn btn-green"
            [class.disabled]="piaForm.invalid"
            >{{ "homepage.cards.item.edit_pia" | translate }}</a
          >
          }
        </div>
        } @if (pia.status != 0 && pia.status != 1) {
        <div class="pia-cardsBlock-item-btn-single">
          <a
            routerLink="/preview/{{ pia.id }}"
            title="{{ 'homepage.cards.item.consult_pia' | translate }}"
            class="btn btn-green"
            [class.disabled]="piaForm.invalid"
            >{{ "homepage.cards.item.consult_pia" | translate }}</a
          >
        </div>
        }
      </div>
    </form>
    }
  </div>
</div>
}
